var map = {
	"./de/triangleIcon.png": "hByC",
	"./en/triangleIcon.png": "1Y+p",
	"./es/triangleIcon.png": "1Mo/",
	"./fr/triangleIcon.png": "whWx",
	"./ja/triangleIcon.png": "pMDd",
	"./ko/triangleIcon.png": "+736",
	"./pt/triangleIcon.png": "K372",
	"./ru/triangleIcon.png": "y4bz",
	"./tc/triangleIcon.png": "HFQQ",
	"./th/triangleIcon.png": "Nw2c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TdJj";